(() => {
  if (window.biaSwatchesBound) return;
  window.biaSwatchesBound = true;
  const pending = new WeakMap();
  function activate(button) {
    const root = button.closest('[data-bia-swatches]');
    const card = button.closest('[data-bia-card], product-card, .product-grid__item');
    if (!root || !card) return;
    const img = card.querySelector('.bia-card__img, .card-gallery img, card-gallery img, .product-card img');
    const src = button.dataset.imageSrc;
    root.querySelectorAll('.bia-swatch').forEach(el => {
      el.classList.toggle('is-active', el === button);
      el.setAttribute('aria-pressed', String(el === button));
    });
    if (button.dataset.variantUrl) card.querySelectorAll('[data-bia-product-link], .product-card__link, [ref="cardGalleryLink"]').forEach(a => a.setAttribute('href', button.dataset.variantUrl));
    if (!img || !src) return;
    const token = {};
    pending.set(img, token);
    card.querySelectorAll('.bia-card__alternate').forEach(el => { el.hidden = true; });
    img.style.opacity = '1';
    img.alt = button.dataset.imageAlt || img.alt;
    img.removeAttribute('srcset');
    img.src = src;
    if (button.dataset.imageSrcset) img.srcset = button.dataset.imageSrcset;
    img.dispatchEvent(new CustomEvent('bia:color-change', {bubbles:true}));
    img.decode?.().catch(() => {
      if (pending.get(img) === token) img.style.opacity = '1';
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.bia-swatch');
    if (!button || !button.closest('[data-bia-swatches]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    activate(button);
  }, true);
})();